import React, { HTMLAttributes, useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { debounce } from 'lodash';
import useContact from '../../../../../../../../hooks/api/useContact';
import { createUseStyles } from '../../../../../../../../theming';
import Contact from '../../../../../../../../interfaces/api/Contact';

interface Props extends HTMLAttributes<HTMLElement> {
  onChange: (event, option?: Contact | null) => void;
  error?: string;
}

const useStyles = createUseStyles({
  optionTitle: {
    fontSize: 14,
  },
  optionSubtitle: {
    color: 'gray',
    fontSize: 12,
  },
  option: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const ContactSelect: React.FC<Props> = ({ className, error, onChange }) => {
  const { getAll } = useContact();
  const [contactQuery, setContactQuery] = useState('');
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    setLoading(true);
    getAll(contactQuery, 1, 5)
      .then((collections) => {
        setContacts(collections.items);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [contactQuery]);

  const handleChangeQuery = debounce((query: string) => {
    setContactQuery(query);
  }, 600);

  return (
    <Autocomplete
      className={className}
      loading={loading}
      options={contacts}
      getOptionLabel={(contact) => `${contact.firstname} ${contact.lastname}`}
      filterOptions={(x) => x}
      includeInputInList
      onChange={onChange}
      loadingText='Chargement'
      noOptionsText='Aucun contact trouvé ...'
      renderOption={(contact: Contact) => (
        <div className={classes.option}>
          <div className={classes.optionTitle}>{`${contact.firstname} ${contact.lastname}`}</div>
          <div className={classes.optionSubtitle}>{contact.email}</div>
        </div>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Contact existant'
          error={error !== undefined}
          helperText={error}
          onChange={(e) => handleChangeQuery(e.target.value)}
          fullWidth
        />
      )}
    />
  );
};

export default ContactSelect;
